// @ts-strict-ignore
/** @jsx jsx */
import React from 'react'
import { jsx, Themed } from 'theme-ui'
import ImgixImg from '../imgix-img.connected'
import classNames from 'classnames'

export default (props) => {
  const { icon, className, variant, displayVariant, showBackground, sys, name, text, link } = props
  const iconEle = <ImgixImg entity={icon} />
  const iconClass = classNames({
    IconBadge: displayVariant === 'badge',
    IconRounded: displayVariant === 'rounded',
    IconTile: displayVariant !== 'badge' && displayVariant !== 'rounded',
  })

  const trackingObject = {
    component_category: 'icon-tile',
    component_id: sys?.id,
    component_name: 'iconTile',
    contentful_name: name,
    contentful_variant: variant,
    link_path: link,
    additionalProps: { text: text },
  }

  const tile =
    variant === 'platinum' ? (
      <div className={iconClass}>
        <div className={`${iconClass}__icon`}>{iconEle}</div>
        <p className={`${iconClass}__text`}>{props.text}</p>
      </div>
    ) : (
      <div
        sx={{
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: displayVariant === 'vertical' ? 'column' : ['column', 'column', 'row'],
          height: displayVariant === 'vertical' ? 136 : [136, 136, 95],
          backgroundColor: showBackground === false ? 'none' : 'white',
          padding: displayVariant === 'vertical' ? 'sm' : ['sm', 'sm', 'lg'],
          paddingTop: 0,
          textAlign: 'center',
          borderRadius: 8,
          textDecoration: 'none',
          variant: 'elements.icon-tile.main',
          ':hover': {
            opacity: 0.9,
          },
          alignItems: 'center',
        }}
        className={classNames({ className, IconTile__compact: variant === 'compact' })}
      >
        <div
          sx={{
            flex: displayVariant === 'vertical' ? 1 : [1, null, 0],
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {iconEle}
        </div>
        <Themed.p
          sx={{
            flex: displayVariant === 'vertical' ? 1 : [null, null, 1],
            marginY: 0,
            variant:
              showBackground === false
                ? 'elements.icon-tile.text.noBackground'
                : 'elements.icon-tile.text',
          }}
        >
          {props.text}
        </Themed.p>
      </div>
    )

  return props.link ? (
    <a
      href={props.link}
      sx={{ textDecoration: 'none' }}
      data-click-tracking={JSON.stringify(trackingObject)}
    >
      {tile}
    </a>
  ) : (
    tile
  )
}
